export * from "@vaadin/slider/vaadin-slider.js";
export * from './generated/Slider.js';
